<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="proposalsService"
    [idKey]="'proposalStepId'"
    [subSectionSettings]="'deleteSettingsProposalSteps'"
/>